<style scoped>

</style>
<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :min-width="180"
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        :placeholder="placeholder"
        v-bind="attrs"
        :value="invoice_info"
        readonly
        v-on="on"
      />
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-select
            v-model="expense.invoice_type"
            :items="invoice_types"
            item-text="name"
            label="发票类型"
            hide-details
            @change="taxDataChange(expense)"
          />
        </v-list-item>
        <v-list-item v-if="is_special_invoice">
          <v-select
            v-model="expense.tax_rate"
            :items="tax_items"
            label="税率"
            hide-details
            @change="taxDataChange(expense)"
          />
        </v-list-item>
        <v-list-item v-if="is_special_invoice">
          <v-text-field
            v-model="expense.tax"
            label="税额"
            hide-details
          />
        </v-list-item>
      </v-list>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="menu = false"
        >
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
  import InvoiceUtil from '../libs/util';
  export default {
    props: {
      expense: {
        type: Object,
        required: true
      },
      label: {
        type: String,
        default: '发票信息'
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        menu: false,
        invoice_types: InvoiceUtil.invoice_types,
        tax_items: [
          {value: '0.0', text: '0%'},
          {value: '0.01', text: '1%'},
          {value: '0.02', text: '2%'},
          {value: '0.03', text: '3%'},
          {value: '0.04', text: '4%'},
          {value: '0.05', text: '5%'},
          {value: '0.06', text: '6%'},
          {value: '0.07', text: '7%'},
          {value: '0.08', text: '8%'},
          {value: '0.09', text: '9%'},
          {value: '0.1', text: '10%'},
          {value: '0.13', text: '13%'},
          {value: '0.16', text: '16%'},
        ]
      }
    },
    computed: {
      // 是否为专票
      is_special_invoice() {
        return this.expense.invoice_type === 1;
      },
      invoice_info() {
        const e = this.expense;
        // 未选择
        if (e.invoice_type === -1) {
          return '';
        }
        let info = `类型: ${InvoiceUtil.getInvoiceType(e.invoice_type)}`;
        // 专票显示其他信息
        if (this.is_special_invoice) {
          info += ` - 税率: ${InvoiceUtil.getTaxRate(e.tax_rate)}`;
          info += ` - 税额: ${this.$util.formatPrice(e.tax)}`;
        }
        return info;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      taxDataChange(expense) {
        if (this.is_special_invoice) {
          const price = expense.price;
          expense.tax = math.eval(`${price} * ${expense.tax_rate} / (1 + ${expense.tax_rate})`).toFixed(2);
        } else {
          expense.tax_rate = '0.0';
          expense.tax = 0;
        }
      },
    }
  }
</script>
